module.exports = __webpack_public_path__ + "img/4.c9cd2b41.png";